export default "__VITE_ASSET__0675b22d__$_?nuxt_component=async__"